<template>
  <div class="g-container g-container-bg">
    <!--详情头部-->
    <div class="com-detail-hd">
      <div class="com-hd-inner"
           :style="{backgroundImage:`url(${backgroundImage})`}">
        <div class="com-hd-info">
          <div class="com-hd-face">
            <img :src="detail.proImage"
                 alt />
          </div>
          <div class="com-hd-name">
            <div class="hd-bottom-td">
              <div class="hd-name-row">{{detail.title}}</div>
              <!--今日信息-->
              <div class="hd-name-row">
                <span>{{detail.timeAgo}}</span>
                <span>{{header.dayOfWeek}}</span>
                <span>天气：{{weather}}</span>
              </div>
            </div>
          </div>
        </div>
        <!--右侧操作-->
        <div class="com-hd-handle">
          <div class="hd-bottom-td">
            <span class="cm-sign-btn"
                  @click="openQiandao">签到详情</span>
            <h-qrcode></h-qrcode>
          </div>
        </div>
      </div>
    </div>
    <div class="m-container m-width">
      <!--面包屑-->
      <div class="crumbs-box">
        <router-link tag="a"
                     class="c-crumbs"
                     :to="{name:'default'}">首页</router-link>
        <span class="c-sep">&gt;</span>
        <span class="c-current">匠心记</span>
        <span class="c-sep">&gt;</span>
        <span class="c-current">{{detail.title}}</span>
      </div>
      <!--主体-->

      <div class="daily-content-p m-structure-content">
        <div class="detail-main-p">
          <!-- 日报 -->
          <div class="daily-main-p"
               v-if="detail.type == '日报'">
            <div class="daily-title-p">
              <div class="mark-p"></div>
              <p class="daily-name-p">{{detail.title}}</p>
              <p class="daily-date-p">发布时间：{{detail.createdTime ? detail.createdTime.slice(0,-9) : ''}}</p>
              <p class="weather-p">
                <span>天气：</span>
                <img :src="weatherIcon"
                     alt />
              </p>
            </div>

            <img-text-item :src="dailyState1"
                           title="项目进度"
                           :text="dailyProp.pschedule"
                           :imgList="PscheduleImage"
                           @openPopImgList="openPopImgList" />

            <div class="daily-item-p">
              <div class="daily-info-left-p">
                <div class="left-options-p">
                  <p>项目名称</p>
                  <p>{{detail.title}}</p>
                </div>
                <div class="left-options-p">
                  <p>项目负责</p>
                  <p>{{dailyProp.projectPartner.join(",")}}</p>
                </div>
                <div class="left-options-p">
                  <p>安全状态</p>
                  <p>{{dailyProp.salfState}}</p>
                </div>
              </div>
              <div class="daily-info-right-p">
                <div class="right-options-p">
                  <p>对策：</p>
                  <p>{{dailyProp.measure}}</p>
                </div>
                <div class="right-options-p">
                  <p>人员人数：</p>
                  <p>{{dailyProp.peopleNum}}</p>
                </div>
                <div class="right-options-p">
                  <p>人员详情：</p>
                  <p>{{dailyProp.sDetail}}</p>
                </div>
              </div>
            </div>

            <img-text-item v-if="dailyProp.Security"
                           :src="dailyState2"
                           title="安全汇报"
                           :text="dailyProp.Security"
                           :imgList="dailyProp.SecurityImage.split(',')"
                           @openPopImgList="openPopImgList" />

            <img-text-item v-if="dailyProp.ThisdayConclusion"
                           :src="dailyState2"
                           title="本日工作总结"
                           :text="dailyProp.ThisdayConclusion"
                           class="no-border-p no-padding-p" />

            <img-text-item v-if="dailyProp.pdiscuss"
                           :src="dailyState2"
                           title="需协调事宜"
                           :text="dailyProp.pdiscuss"
                           class="no-border-p no-padding-p" />

            <img-text-item v-if="dailyProp.pother"
                           :src="dailyState2"
                           title="其他情况汇报"
                           :text="dailyProp.pother"
                           class="no-border-p no-padding-p" />
          </div>

          <!-- 周报 -->
          <div class="report-main-p"
               v-if="detail.type == '周报'">
            <h2>周报</h2>
            <div class="report-title-p">
              <p class="report-date-p">发布时间：{{detail.createdTime ? detail.createdTime.slice(0,-9) : ''}}</p>
              <p class="weather-p">
                <span>天气：</span>
                <img :src="weatherIcon"
                     alt />
              </p>
              <div class="icon-box-p">
                <div class="hits-icon-p">
                  <div></div>
                  <span>{{detail.hits}}</span>
                </div>
                <div class="rep-icon-p">
                  <div></div>
                  <span>{{detail.repNum}}</span>
                </div>
              </div>
            </div>

            <div class="daily-item-p"
                 v-if="postData1.length > 0">
              <div class="item-title-p">
                <img :src="reportState1"
                     alt />
                <span>本周项目进度总结</span>
              </div>
              <ul>
                <li v-for="(item,index) of postData1"
                    :key="index">
                  <div v-if="item.type=='文字'"
                       class="item-content-p">
                    <pre>{{item.content}}</pre>
                  </div>

                  <div class="item-img-p">
                    <img v-for="(img,imgIndex) of item.type=='图片' ? item.content.split(',') : ''"
                         :src="img"
                         :key="imgIndex"
                         @click="openPopImgList(item.content.split(','),imgIndex)" />
                  </div>
                </li>
              </ul>
            </div>

            <img-text-item v-if="dailyPropertyWeeks.Pschedule"
                           :src="reportState1"
                           title="本周项目进度总结"
                           :text="dailyPropertyWeeks.Pschedule"
                           :imgList="dailyPropertyWeeks.PscheduleImage.split(',')"
                           @openPopImgList="openPopImgList" />

            <img-text-item v-if="dailyPropertyWeeks.Security"
                           :src="reportState2"
                           title="本周安全情况总结"
                           :text="dailyPropertyWeeks.Security"
                           :imgList="dailyPropertyWeeks.SecurityImage.split(',')"
                           @openPopImgList="openPopImgList" />

            <img-text-item v-if="dailyPropertyWeeks.ThisdayConclusion"
                           :src="reportState3"
                           title="本周工作总结以及下周工作计划"
                           :text="dailyPropertyWeeks.ThisdayConclusion" />
          </div>

          <!-- QE -->
          <!-- 封面 -->
          <div class="cover-p"
               v-if="detail.type == 'QE'">
            <div class="cover-head-p">
              <h3>{{detail.title}}</h3>
              <div class="head-other-p">
                <div class="date-p">
                  <span>发布时间：{{detail.createdTime ? detail.createdTime.slice(0,-9) : ''}}</span>
                </div>
                <div class="weather-p">
                  <span>天气：</span>
                  <img :src="weatherIcon"
                       alt />
                </div>
                <div class="icon-box-p">
                  <div class="hits-icon-p">
                    <div></div>
                    <span>{{detail.hits}}</span>
                  </div>
                  <div class="rep-icon-p">
                    <div></div>
                    <span>{{detail.repNum}}</span>
                  </div>
                </div>
              </div>
              <div class="content-p"
                   v-if="PostCoverImage">
                <div class="content-img-p">
                  <img :src="PostCoverImage"
                       alt />
                </div>
                <div class="content-text-p">
                  <p>{{PostCoverName}}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 节点状态 -->
          <div class="node-state-p"
               ref="node"
               v-if="nodeArr.length>0 && detail.type == 'QE'">
            <ul>
              <li v-for="(item,index) of nodeArr"
                  :key="item.content.nodeName+index"
                  class="state-item-p">
                <div class="item-box-p"
                     :class="changeStateClass(item.content.nodeState)"
                     @click="scrollTo(index)">
                  <span>{{item.content.nodeName}}</span>
                  <span>质量：{{item.content.nodeState | nodeState}}</span>
                  <div></div>
                </div>
              </li>
            </ul>
            <div class="state-line-p"></div>
          </div>

          <!-- 质量安全部分内容 -->
          <main-content v-if="detail.type == 'QE' && detail.isNewPost == true"
                        :postData="postData1"
                        :pointList="qualityPoint"
                        ref="quality"
                        class="quality-content-p"
                        @openPopImgList="openPopImgList" />

          <!-- 材料安全部分内容 -->
          <main-content v-if="detail.type == 'QE' && detail.isNewPost == true"
                        :postData="postData2"
                        title="材料安全篇"
                        :pointList="materialPoint"
                        :postUser="postUser"
                        ref="material"
                        class="material-content-p"
                        @openPopImgList="openPopImgList" />
          <div v-if="detail.isNewPost == false">
            <div v-html="detail.content"
                 id="divImg"></div>
          </div>
          <!-- 评论列表 -->
          <div class="structure-border comment-p"
               id="toCommentBox"
               ref="comment">
            <to-comment @jxjAddReplis="jxjAddReplis"
                        :headImage="detail.postUser && detail.postUser.headImage"></to-comment>
            <comment-box :commentList="detail.reps"
                         :replyBtnDir="true"
                         @showReplayFunc="showReplayFunc">
              <template scope="props">
                <reply-comment :replyId="props.rowdata.id"
                               @jxjAddReplis="jxjAddReplis"></reply-comment>
              </template>
            </comment-box>
          </div>
        </div>

        <!-- 右侧功能栏 -->
        <div class="m-structure-quick">
          <div class="structure-btn"
               @click="gotoCreate">发布内容</div>
          <div class="structure-box"
               v-if="detail.postUser">
            <div class="com-md-face">
              <img :src="detail.postUser.headImage"
                   alt />
            </div>
            <div class="str-row">
              <span class="str-label">{{detail.postUser.type}}</span>
              <i class="star-icon"
                 :class="detail.postUser.starClass"></i>
            </div>
            <div class="str-row">
              <span class="str-name">{{detail.postUser.nickName}}</span>
              <span class="str-tag-icon">{{detail.postUser.tags[0]}}</span>
            </div>
          </div>
          <div class="structure-box pd-small"
               v-if="detail.likeImgs && detail.likeImgs.length > 0">
            <div class="like-people-like">
              <div class="lik-list">
                <div class="lik-face"
                     v-for="(item,i) in detail.likeImgs"
                     :key="i">
                  <img :src="item"
                       alt />
                </div>
                <div class="lik-more-tipper">...等{{detail.likeImgs.length}}人点赞</div>
              </div>
            </div>
          </div>
          <div class="structure-box postDetail"
               v-if="detail.zjfb && detail.zjfb.length >0 && detail.type == 'QE'">
            <div class="common-tit-h2">
              <b>最近发布报告</b>
            </div>
            <div class="nearly-report">
              <div class="nearly-row"
                   v-for="(item,i) in detail.zjfb"
                   :key="i">
                <router-link tag="a"
                             :to="{name:'jxjPostDetail',params:{id:item.id}}">{{item.title}}</router-link>
                <p>{{item.createdTime.split(' ')[0]}}</p>
              </div>
            </div>
          </div>
          <div class="structure-box"
               v-if="detail.zjfb && detail.zjfb.length >0 && detail.type == '图文'">
            <div class="common-tit-h2">
              <b>最近主题</b>
            </div>
            <div class="nearly-report">
              <div class="nearly-row"
                   v-for="(item,i) in detail.zjfb"
                   :key="i">
                <router-link tag="a"
                             :to="{name:'jxjPostDetail',params:{id:item.id}}">{{item.title}}</router-link>
                <p>{{item.createdTime.split(' ')[0]}}</p>
              </div>
            </div>
          </div>
          <div class="structure-box"
               v-if="detail.zjfb && detail.zjfb.length >0 && detail.type == '周报'">
            <div class="common-tit-h2 has-line">
              <i class="weekly-icon">周</i>
              <b>往期周报</b>
            </div>
            <div class="history-weekly-report">
              <div class="weekly-item"
                   v-for="(item,i) in detail.zjfb"
                   :key="i">
                <div class="weekly-face">
                  <img :src="item.headImage"
                       alt />
                </div>
                <div class="weekly-info">
                  <router-link tag="a"
                               :to="{name:'jxjPostDetail',params:{id:item.id}}"
                               class="weekly-name">{{item.title}}</router-link>
                  <div class="weekly-time">{{item.createdTime.split(' ')[0]}}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="structure-box"
               v-if="detail.zjfb && detail.zjfb.length >0 && detail.type == '日报'">
            <div class="common-tit-h2">
              <b>历史日报</b>
            </div>
            <div class="his-daily">
              <router-link class="his-daily-item"
                           :to="{name:'jxjPostDetail',params:{id:item.id}}"
                           v-for="(item,i) in detail.zjfb"
                           :key="i">
                <span class="his-time">{{item.timeStr}}</span>
                <span class="stroke-tag-circle">{{item.salfState}}</span>
              </router-link>
            </div>
          </div>
          <div class="scan-code-quick">
            <div class="code-quick-pic">
              <qrcode-vue :value="localHref"
                          :size="170"
                          level="H"></qrcode-vue>
            </div>
          </div>
        </div>
      </div>

      <d-qiandao v-if="qiandaoDir"
                 @close="closeQiandao"></d-qiandao>
      <to-top v-if="detail.type != 'QE'"
              :isLike="detail.isLike"
              @likeFunc="likeFunc"
              :id="reParams.id"></to-top>
      <qe-aside-right v-if="detail.type == 'QE'"
                      @scrollToNode="scrollToNode"
                      @scrollToQuality="scrollToQuality"
                      @scrollToMaterial="scrollToMaterial"
                      @scrollToComment="scrollToComment"
                      @scrollToTop="scrollToTop"
                      :isLike="isLike" />

      <div class="shadow-fixed show"
           v-if="currentImgShow">
        <div class="mask"></div>
        <div class="bomb-com-box full-bomb">
          <div class="bomb-small-close"
               @click="closePopimglist"></div>
          <div class="qe-view-detail">
            <div class="cp-column cp-bomb-full cp-swiper">
              <swiper :options="swiperOption">
                <swiper-slide v-for="(item,index) in currentImgList"
                              :key="index">
                  <img :src="item" />
                </swiper-slide>
                <div class="swiper-button-prev"
                     slot="button-prev"></div>
                <div class="swiper-button-next"
                     slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import 'swiper/dist/css/swiper.css';
import '../../../../html/components/crumbs/crumbs.scss';
import '../../../../html/components/detailHd/detailHd.scss';
import '../../../../html/components/tabs/tabs.scss';

import '../../../../html/components/structure/structure.scss';
import '../../../../html/components/enterprise/enterprise.scss';
import '../../../../html/components/picture/picture.scss';
import '../../../../html/components/comments/comments.scss';

import '../../../../html/pages/originality/daily/daily.scss';
import '../../../../html/pages/originality/qe/qe.scss';

import '../../../../html/components/fixBar/fixBar.scss';

import toTop from '../../../../components/to-top/to-top.vue';
import dQiandao from '../detail/components/d-qiandao.vue';
import commentBox from '../../../../components/comment-box/comment-box.vue';
import replyComment from '../../../../components/comment-box/reply-comment.vue';
import toComment from '../../../../components/to-comment/to-comment.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import daily from './components/daily.vue';
import noDaily from './components/noDaily.vue';
import mainContent from './components/mainContent.vue'
import qeAsideRight from './components/qeAsideRight.vue'
import imgTextItem from './components/imgTextItem.vue'

import { getJxjPostDetail, getJxjDetail, getWeather, jxjAddReplis } from '../../../../api';
import stars from '../../../../pubilc/util/stars';
import timeago from '../../../../pubilc/util/timeago';
import hQrcode from '../../../../components/h-qrcode/h-qrcode';
import { jxjGetProQEReport } from "../../../../api/index"

import QrcodeVue from 'qrcode.vue';

export default {
  name: 'postDetail',
  data () {
    return {
      localHref: location.href,
      currentImgShow: false,
      qiandaoDir: false,
      header: {},
      detail: {},
      weather: '',
      reParams: {
        id: this.$route.params.id,
        repId: '',
        content: ''
      },
      swiperOption: {
        initialSlide: 0,
        simulateTouch: false,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      currentImgList: [

      ],
      backgroundImage: '',
      sunnyImage: './gif/sunny.gif',
      hotImage: './gif/hot.gif',
      rainImage: './gif/rain.gif',
      snowImage: './gif/snow.gif',
      cloudyImage: './gif/cloudy.gif',
      fogImage: './gif/fog.gif',
      sunnyIcon: require('../../../../html/pages/originality/qe/images/sunny.png'),
      hotIcon: require('../../../../html/pages/originality/qe/images/hot.png'),
      rainIcon: require('../../../../html/pages/originality/qe/images/rain.png'),
      snowIcon: require('../../../../html/pages/originality/qe/images/snow.png'),
      cloudyIcon: require('../../../../html/pages/originality/qe/images/cloudy.png'),
      fogIcon: require('../../../../html/pages/originality/qe/images/fog.png'),
      weatherIcon: "",
      PostCoverImage: "",
      PostCoverName: "",
      nodeArr: [],
      postData1: [],//质量内容
      postData2: [],//材料内容，
      qualityPoint: [],
      materialPoint: [],
      postUser: {},
      isLike: false,
      dailyProp: {},//日报信息
      dailyPropertyWeeks: {},//周报信息
      PscheduleImage: [],
      dailyState1: require('../../../../html/pages/originality/qe/images/daily_state1.png'),
      dailyState2: require('../../../../html/pages/originality/qe/images/daily_state2.png'),
      dailyState3: require('../../../../html/pages/originality/qe/images/daily_state3.png'),
      dailyState4: require('../../../../html/pages/originality/qe/images/daily_state4.png'),
      dailyState5: require('../../../../html/pages/originality/qe/images/daily_state5.png'),
      reportState1: require('../../../../html/pages/originality/qe/images/report_state1.png'),
      reportState2: require('../../../../html/pages/originality/qe/images/report_state2.png'),
      reportState3: require('../../../../html/pages/originality/qe/images/report_state3.png'),
    }
  },
  components: {
    swiper,
    swiperSlide,
    commentBox,
    replyComment,
    toComment,
    toTop,
    daily,
    noDaily,
    hQrcode,
    dQiandao,
    QrcodeVue,
    mainContent,
    qeAsideRight,
    imgTextItem
  },
  methods: {
    // async getHeader() {
    //     let res = await getJxjDetail({
    //         id: this.$route.query.xid
    //     });
    //     if (res.Type == 'Success') {
    //         res.Data.timeAgo = timeago(new Date(res.Data.creatTime));
    //         this.header = res.Data;
    //         // console.log(this.header);
    //     }
    // },
    openPopImgList (imgList, index) {

      this.currentImgList = imgList;
      this.swiperOption.initialSlide = index;
      this.currentImgShow = true;

    },
    closePopimglist () {
      this.currentImgShow = false;
    },
    gotoCreate () {
      if (this.detail.type == 'QE') {
        this.getProQEReport()
      } else if (this.detail.type == '周报') {
        this.$router.push({ name: 'createReport', params: { id: this.detail.proId }, query: { type: 'ZB' } })
      } else if (this.detail.type == '日报') {
        this.$router.push({ name: 'createDaliy', params: { id: this.detail.proId }, query: { title: this.detail.title } })
      } else if (this.detail.type == '普通' || this.detail.type == '图文') {
        this.$router.push({ name: 'createQE', params: { id: this.detail.proId }, query: { type: 'ZT' } });
      }
    },
    async getProQEReport () {
      let res = await jxjGetProQEReport({
        projectId: this.detail.proId,
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      })
      if (res.Type == "Success") {
        let qeBoolean = res.Data.hasQE
        if (qeBoolean) {
          let qeId = res.Data.qeId
          this.$router.push({ name: 'updateQEReport', params: { id: this.detail.proId, qeId: qeId }, query: { type: 'QE' } })
        } else {
          this.$router.push({ name: 'createQEReport', params: { id: this.detail.proId }, query: { type: 'QE' } })
        }

      } else if (res.Type == 'Error' || 'Warning' == res.Type) {
        this.$layer.alert(res.Content);
      }
    },
    closeQiandao () {
      this.qiandaoDir = false;
    },
    openQiandao () {
      this.qiandaoDir = true;
    },
    async getData () {
      let res = await getJxjPostDetail({
        id: this.$route.params.id
      });
      if (res.Type == 'Success') {
        res.Data.timeAgo = timeago(new Date(res.Data.createdTime));
        if (res.Data.postUser) {
          res.Data.postUser.starClass = stars(res.Data.postUser.star);
        }
        res.Data.zjfb.forEach(item => {
          item.timeAgo = timeago(new Date(item.createdTime));
          let ti = item.createdTime.split(' ')[0].split('-');
          item.timeStr = ti[0] + '年' + ti[1] + '月' + ti[2] + '日';
        });
        res.Data.reps.forEach(item => {
          item.showReplay = false;
          item.timeAgo = timeago(new Date(item.createdTime));
        })

        // 保存数据
        this.detail = res.Data;
        this.postData1 = res.Data.postData
        this.postUser = res.Data.postUser
        this.isLike = res.Data.isLike

        if (this.detail.type == "日报") {
          this.dailyProp = res.Data.dailyProp
          if (this.dailyProp.imgs.length > 0) {
            this.PscheduleImage = this.dailyProp.imgs
          } else {
            this.PscheduleImage = this.dailyProp.PscheduleImage.split(",")
          }
        } else if (this.detail.type == "周报") {
          this.dailyPropertyWeeks = res.Data.dailyPropertyWeeks

        } else if (this.detail.type == "QE") {
          this.postData1.forEach(item => {
            if (item.type == "节点") {
              item.content = JSON.parse(item.content)
            }
          })
          this.postData2 = res.Data.postData2
          if (this.postData2.length == 0) {
            if (this.$refs.material) {
              this.$refs.material.contentIsShow = false
            }
          }
          this.createNodeData(this.postData1)
          this.qualityPoint = res.Data.qeInfo1.qePoint
          if (res.Data.qeInfo2) {
            this.materialPoint = res.Data.qeInfo2.qePoint
          }
          this.getDetail()
        }
      } else {
        this.$layer.alert(res.Content);
      }

    },
    async getWeather () {
      let res = await getWeather({
        city: '苏州'
      });
      if (res.Type == 'Success') {
        this.weather = res.Data;
        switch (this.weather) {
          case "晴":
            this.backgroundImage = this.sunnyImage;
            this.weatherIcon = this.sunnyIcon;
            break;
          case "高温":
            this.backgroundImage = this.hotImage;
            this.weatherIcon = this.hotIcon;
            break;
          case "雨":
            this.backgroundImage = this.rainImage;
            this.weatherIcon = this.rainIcon;
            break;
          case "雪":
            this.backgroundImage = this.snowImage;
            this.weatherIcon = this.snowIcon;
            break;
          case "雾":
            this.backgroundImage = this.fogImage;
            this.weatherIcon = this.fogIcon;
            break;
          case "阴":
            this.backgroundImage = this.cloudyImage;
            this.weatherIcon = this.cloudyIcon;
            break;
        }
      }
    },
    async jxjAddReplis (content, repId) {
      this.reParams.content = content;
      if (repId) {
        this.reParams.repId = repId;
      } else {
        this.reParams.repId = '';
      }
      let res = await jxjAddReplis(this.reParams);
      if (res.Type == 'Success') {
        this.$layer.alert(res.Content);
        this.getData();
      } else {
        this.$layer.alert(res.Content);
      }
    },
    showReplayFunc (index) {
      // debugger;
      this.detail.reps[index].showReplay = !this.detail.reps[index].showReplay;
    },
    //点赞
    likeFunc (type) {
      if (type == 1) {
        this.detail.isLike++;
      } else if (type == 2) {
        this.detail.isLike--;
      }
    },

    async getDetail () {
      let res = await getJxjDetail({
        id: this.detail.proId
      })
      if (res.Type == 'Success') {
        this.PostCoverImage = res.Data.PostCoverImage
        this.PostCoverName = res.Data.PostCoverName
        console.log(res)

      }
    },
    createNodeData (arr) {
      this.nodeArr = arr.filter(item => {
        return item.type == "节点"
      })
    },
    changeStateClass (state) {
      switch (state) {
        case 1:
          return "state1"
        case 2:
          return "state2"
        case 3:
          return "state3"
      }
    },
    scrollTo (index) {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.quality.$refs.node[index].offsetTop - 60
    },
    scrollToNode () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.node.offsetTop - 60
    },
    scrollToQuality () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.quality.$el.offsetTop - 60
    },
    scrollToMaterial () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.material.$el.offsetTop - 60
    },
    scrollToComment () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.comment.offsetTop - 60
    },
    scrollToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
  },
  created () {
    // this.getHeader();
    this.getWeather();
    this.getData();

  },
  watch: {
    $route (to, from) {
      this.getWeather();
      this.getData();
    }
  },
  filters: {
    nodeState (val) {
      switch (val) {
        case 1:
          return "良好"
        case 2:
          return "预警"
        case 3:
          return "异常"
      }
    }
  },
}
</script>

<style>
#divImg p img {
  width: 600px;
}
p {
  font-size: 20px;
  text-align: center;
}
</style>
